var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"hidden-xs-up"},[_vm._v(" "+_vm._s(_vm._f("shortDate")(_vm.data.dateSubmitted))+" ")]),_vm._v(" "+_vm._s(_vm._f("shortDate")(_vm.data.dateSubmitted))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }